import DocumentViewerModal from "components/DocumentViewer";
import { StatusChip } from "components/StatusChip";
import { useHasRole } from "contexts/AuthContext";
import { useTranslation } from "contexts/i18nContext";
import { useState } from "react";
import { Appeal, Complaints } from "types";
import { APPEAL_STATUS, APPEAL_TYPE } from "utils/constantValues";
import { ROLES } from "utils/roles";

import AddAppealFeedbackModal from "../../complaintRequest/fragments/AddAppealFeedbackModal";
import AddAppealRegistrationModal from "../../complaintRequest/fragments/AddAppealRegistrationModal";
import AddEvaluationModal from "./AddEvaluationModal";
import HearingHistoryModal from "./HearingHistoryModal";
import UpdateAppealDocModal from "./UpdateAppealDocModal";
import ViewEvaluationModal from "pages/complaintRequest/fragments/ViewEvaluationModal";

interface AppealProps {
  complaintData: Complaints;
  appealData: Appeal[];
  onAppealRefresh: any;
  showHearingHistory?: Boolean;
  showAddRegistration?: Boolean;
  hideAppealType?: Boolean;
}

export default function AppealCard({
  complaintData,
  appealData,
  showHearingHistory = false,
  onAppealRefresh,
  showAddRegistration = false,
  hideAppealType = false,
}: AppealProps) {
  const { t } = useTranslation();
  const canCreateAppealFeedback = useHasRole([
    ROLES.INSPECTION_DIRECTOR,
    ROLES.INSPECTION_COORDINATOR,
  ]);
  const canViewAppealFeedback = useHasRole([
    ROLES.INSPECTION_DIRECTOR,
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canAddEvaluation = useHasRole([ROLES.INSPECTION_COORDINATOR]);
  const canViewEvaluation = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canRegisterAppealDoc = useHasRole([ROLES.INSPECTION_PROSECUTOR]);

  const isRegistrar = useHasRole([ROLES.INSPECTION_REGISTRAR]);

  const [isOpen, setIsOpen] = useState(false);
  const [showDailyHearing, setShowDailyHearing] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [selectedAppeal, setSelectedAppeal] = useState<Appeal | null>(null);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);

  const [isEvaluationFormOpen, setIsEvaluationFormOpen] = useState(false);
  const [isEvaluationViewOpen, setIsEvaluationViewOpen] = useState(false);

  return (
    <div className="space-y-4">
      {/* ////////////// */}
      {appealData?.map((obj: any) => (
        <div
          key={obj?.id}
          className="bg-white shadow-md rounded-xl p-4 w-full border-l-8 border-black mx-auto"
        >
          {/* Header */}
          {/* <div className="flex items-center gap-3 mb-4">
          <img
            src={require("../../../images/avatar.png")}
            alt="profile"
            className="w-10 h-10 rounded-full object-cover"
          />
          <div>
            <h2 className="text-sm font-semibold">Senay Daniel</h2>
            <p className="text-xs text-gray-500">Investigation Team</p>
          </div>
        </div> */}
          {/* Evaluation Add/View Button (inspired by provided code) */}

          {/* ...existing code... */}

          {/* <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
          <p className="block text-gray-600">Uploaded Date</p>
          <p className="block text-black font-medium">
            {new Date()?.toDateString() || "-"}
          </p>
          </div>
          <hr />
           */}

          {/* New: Council Office Verdicts Section */}
          {obj?.council_office_verdicts &&
            obj.council_office_verdicts.length > 0 && (
              <div className="mt-4">
                <p className="text-[#002855] font-medium mb-2">
                  {t("officeOfCouncilDecision")}
                </p>
                {obj.council_office_verdicts.map((verdict: any, index: any) => (
                  <div
                    key={verdict.id}
                    className="border border-gray-200 rounded-md p-3 mb-3"
                  >
                    <p className="font-semibold text-sm mb-2">
                      {t("decision")} {index + 1}
                    </p>

                    {verdict.council_decision_day && (
                      <div className="flex justify-between py-1">
                        <span className="text-gray-600">
                          {t("decisionDay")}
                        </span>
                        <span className="font-medium">
                          {verdict.council_decision_day}
                        </span>
                      </div>
                    )}

                    {verdict.council_decision_type && (
                      <div className="flex justify-between py-1">
                        <span className="text-gray-600">
                          {t("decisionType")}
                        </span>
                        <span className="font-medium">
                          {verdict.council_decision_type}
                        </span>
                      </div>
                    )}

                    {verdict.given_order && (
                      <div className="flex justify-between py-1">
                        <span className="text-gray-600">{t("givenOrder")}</span>
                        <span className="font-medium">
                          {verdict.given_order}
                        </span>
                      </div>
                    )}

                    {verdict.council_decision_summary && (
                      <div className="py-1">
                        <span className="text-gray-600 block">
                          {t("decisionSummary")}
                        </span>
                        <p className="text-gray-700 mt-1">
                          {verdict.council_decision_summary}
                        </p>
                      </div>
                    )}

                    {verdict.accused_prosecutor_name && (
                      <div className="flex justify-between py-1">
                        <span className="text-gray-600">
                          {t("accusedProsecutor")}
                        </span>
                        <span className="font-medium">
                          {verdict.accused_prosecutor_name}
                        </span>
                      </div>
                    )}

                    {verdict.documents && verdict.documents.length > 0 && (
                      <div className="mt-2">
                        <DocumentViewerModal
                          documents={verdict.documents}
                          baseUrl={`${process.env.REACT_APP_API_BASE_URL}prosecutor-decipiline/complaint-termination-documents/document`}
                        />
                      </div>
                    )}
                    <hr className="my-2" />
                  </div>
                ))}
              </div>
            )}

          {obj?.verdict_given_on_intialday_ins && (
            <div>
              {obj?.council_decision_day && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-3">
                  <p className="block  text-gray-600">{t("decisionDay")}</p>
                  <p className="block  text-black font-medium">
                    {obj?.council_decision_day || "-"}
                  </p>
                </div>
              )}
              <hr />
              {obj?.council_decision_type && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-3">
                  <p className="block  text-gray-600">{t("decisionType")}</p>
                  <p className="block  text-black font-medium">
                    {obj?.council_decision_type || "-"}
                  </p>
                </div>
              )}
              <hr />
              {obj?.discipline_measure_type && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-3">
                  <p className="block  text-gray-600">
                    {t("decisionMeasureType")}
                  </p>
                  <p className="block  text-black font-medium">
                    {obj?.discipline_measure_type || "-"}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* Info Rows */}
          <div className="my-3">
            <p className="text-[#002855] font-medium">
              {t("memorandumSummary")}
            </p>
            <p className="text-gray-700 mt-1">{obj?.memorandum_summary}</p>
          </div>

          {obj?.appeal_documents && obj?.appeal_documents.length > 0 && (
            <DocumentViewerModal
              documents={obj?.appeal_documents}
              baseUrl={`${process.env.REACT_APP_API_BASE_URL}prosecutor-decipiline/complaint-termination-documents/document`}
            />
          )}

          <div className="mb-6 ">
            {!hideAppealType && obj?.appeal_type && (
              <div className="w-full flex flex-wrap items-center justify-between gap-4 my-3">
                <p className="block  text-gray-600">{t("appealType")}</p>
                <p className="block  text-black font-medium">
                  {obj?.appeal_type === APPEAL_TYPE.ACCUSED_PROSECUTOR_TO_COURT
                    ? t("appealFromInspectionToCourt")
                    : t("appealFromInspectionToCouncil")}
                </p>
              </div>
            )}
            <hr />
            {obj?.registration_date && (
              <div className="w-full flex flex-wrap items-center justify-between gap-4 my-3">
                <p className="block  text-gray-600">{t("registeredDate")}</p>
                <p className="block  text-black font-medium">
                  {obj?.registration_date || "-"}
                </p>
              </div>
            )}

            {obj?.registration_number && (
              <div className="w-full flex flex-wrap items-center justify-between gap-4 my-3">
                <p className="block  text-gray-600">{t("registeredNumber")}</p>
                <p className="block  text-black font-medium">
                  {obj?.registration_number || "-"}
                </p>
              </div>
            )}
          </div>

          <div className="flex flex-row gap-4">
            {canAddEvaluation &&
              obj &&
              obj?.evaluations?.length === 0 &&
              obj?.appeal_feedback_status === "approved" && (
                <div
                  className="flex flex-col items-center justify-center gap-2 cursor-pointer mt-3 w-12"
                  onClick={() => {
                    setSelectedAppeal(obj);
                    setIsEvaluationFormOpen(true);
                  }}
                >
                  <div className="w-12 h-12 flex items-center justify-center gap-2 bg-gradient-to-r from-red-100 to-red-200 border-2 border-red-300 rounded-full shadow hover:from-red-200 hover:to-red-300 transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-red-400">
                    <span className="flex items-center justify-center w-8 h-8 border-red-200 rounded-full">
                      <svg
                        className="w-5 h-5 text-red-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    </span>
                  </div>
                  <span className="font-thin text-red-700 text-xs text-center">
                    {t("addEvaluation")}
                  </span>
                </div>
              )}

            {canViewEvaluation && obj && obj?.evaluations?.length > 0 && (
              <div
                className="flex flex-col items-center justify-center gap-2 cursor-pointer mt-3 w-12"
                onClick={() => {
                  setSelectedAppeal(obj);
                  setIsEvaluationViewOpen(true);
                }}
              >
                <div className="w-12 h-12 flex items-center justify-center gap-2 bg-gradient-to-r from-red-100 to-red-200 border-2 border-red-300 rounded-full shadow hover:from-red-200 hover:to-red-300 transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-red-400">
                  <span className="flex items-center justify-center w-8 h-8 border-red-200 rounded-full">
                    <svg
                      className="w-5 h-5 text-red-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  </span>
                </div>
                <span className="font-thin text-red-700 text-xs text-center">
                  {t("viewEvaluation")}
                </span>
              </div>
            )}
            {canViewAppealFeedback && obj?.feedback_on_memorandum && (
              <div className="flex-1 bg-gray-200 p-5 rounded-md">
                <div className="flex items-center justify-between mb-2">
                  <p className="font-medium ">{t("feedbackOnMemorandum")}</p>
                  <StatusChip status={obj?.appeal_feedback_status ?? null} />
                </div>
                <p className="text-sm leading-relaxed">
                  {obj?.feedback_on_memorandum || "-"}
                </p>
              </div>
            )}
          </div>

          {obj?.if_reject_comment && (
            <div className="border-4 border-red-600 bg-red-50 p-4 rounded-md my-3">
              <p className="text-black font-bold">{t("rejectComment")}</p>
              <p className="text-black mt-1">{obj?.if_reject_comment}</p>
            </div>
          )}

          {showHearingHistory && (
            <button
              className="w-full bg-[#5f5f5f] hover:bg-gray-800 border border-white text-white py-2 rounded-lg mt-2"
              onClick={() => {
                setSelectedAppeal(obj);
                setShowDailyHearing(true);
              }}
            >
              {t("showDailyHearingHistory")}
            </button>
          )}

          {canCreateAppealFeedback &&
            obj?.appeal_status !== APPEAL_STATUS.APPROVED &&
            !obj?.feedback_on_memorandum && (
              <button
                className="w-full bg-[#5f5f5f] hover:bg-gray-800 border border-white text-white py-2 rounded-lg mt-2"
                onClick={() => {
                  setSelectedAppeal(obj);
                  setIsFeedbackOpen(true);
                }}
              >
                {t("addFeedbackOnMemorandum")}
              </button>
            )}

          {(canRegisterAppealDoc || isRegistrar) &&
            (isRegistrar ? true : showAddRegistration) &&
            obj?.feedback_on_memorandum &&
            !obj?.registration_number && (
              <div className="text-right mt-3">
                <button
                  className="bg-black text-white px-14 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => {
                    setSelectedAppeal(obj);
                    setIsOpen(true);
                  }}
                >
                  {t("addRegistrationNo")}
                </button>
              </div>
            )}

          {canRegisterAppealDoc &&
            obj?.appeal_feedback_status === "respond_back" &&
            !obj?.registration_number && (
              <div className="text-right mt-3">
                <button
                  className="bg-black text-white px-14 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => {
                    setSelectedAppeal(obj);
                    setIsUpdateOpen(true);
                  }}
                >
                  {t("updateMemorandum")}
                </button>
              </div>
            )}

          {complaintData && (
            <AddAppealFeedbackModal
              isOpen={isFeedbackOpen}
              setIsOpen={setIsFeedbackOpen}
              complaintData={complaintData}
              appealData={selectedAppeal as Appeal}
              onRefresh={onAppealRefresh}
            />
          )}

          {selectedAppeal && isOpen && (
            <AddAppealRegistrationModal
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              complaintData={complaintData}
              appealData={selectedAppeal as Appeal}
              onRefresh={onAppealRefresh}
            />
          )}
        </div>
      ))}

      {complaintData && (
        <HearingHistoryModal
          isOpen={!!showDailyHearing}
          onClose={() => setShowDailyHearing(false)}
          appealData={selectedAppeal as Appeal}
          complaintData={complaintData}
        />
      )}

      {selectedAppeal && isUpdateOpen && (
        <UpdateAppealDocModal
          isOpen={isUpdateOpen}
          setIsOpen={setIsUpdateOpen}
          complaintData={complaintData}
          appealData={selectedAppeal as Appeal}
          onRefresh={onAppealRefresh}
        />
      )}

      {selectedAppeal && (
        <AddEvaluationModal
          isOpen={isEvaluationFormOpen}
          setIsOpen={setIsEvaluationFormOpen}
          onRefresh={onAppealRefresh}
          appeal={selectedAppeal as Appeal}
        />
      )}
      {selectedAppeal && (
        <ViewEvaluationModal
          isOpen={isEvaluationViewOpen}
          setIsOpen={setIsEvaluationViewOpen}
          evaluations={selectedAppeal.evaluations}
        />
      )}
    </div>
  );
}
